<template>
  <div class="content-wrap">
    <div class="main">
      <div class="left-wrapper">
        <div class="title-part">
          <h2>Compare</h2>
          <h2>Analyze</h2>
          <h2>Manage</h2>
          <h1 class="light-green">Make Profit</h1>
        </div>
        <p></p>
        <div class="left-bottom-wrapper">
          <SignInButton :text="'Sign In With'"></SignInButton>
        </div>
      </div>
      <div class="right_wrapper">
        <div class="f g30">
          <div class="box">
            <img
              class="game_icon unselectable"
              :src="gameIcons.cs2"
              alt="CS2"
            />
            <img
              class="featured_image unselectable"
              :src="csItem.icon"
              alt="CS2"
            />
            <div class="info">
              <h6>{{ csItem.name }}</h6>
              <div class="f align-center g5">
                <VueIcon
                  icon="solar:tag-price-linear"
                  color="2bce7b"
                  height="24px"
                  width="24px"
                ></VueIcon>
                <h5 style="color: #2bce7b">${{ csItem.price }}</h5>
              </div>
            </div>
          </div>
          <div class="box">
            <img
              class="game_icon tf2_game_icon unselectable"
              :src="gameIcons.tf2"
              alt="TF2"
            />
            <img
              class="featured_image tf_key unselectable"
              :src="tfItem.icon"
              alt="TF2"
            />
            <div class="info">
              <h6>{{ tfItem.name }}</h6>
              <div class="f align-center g5">
                <VueIcon
                  icon="solar:tag-price-linear"
                  color="2bce7b"
                  height="24px"
                  width="24px"
                ></VueIcon>
                <h5 style="color: #2bce7b">${{ tfItem.price }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 30px"></div>
        <div class="f g30">
          <div class="hidden" style="width: 80px"></div>
          <div class="box">
            <img
              class="game_icon unselectable"
              :src="gameIcons.dota2"
              alt="Dota2"
            />
            <img class="featured_image" :src="dotaItem.icon" alt="Dota2" />
            <div class="info">
              <h6>{{ dotaItem.name }}</h6>
              <div class="f align-center g5">
                <VueIcon
                  icon="solar:tag-price-linear"
                  color="2bce7b"
                  height="24px"
                  width="24px"
                ></VueIcon>
                <h5 style="color: #2bce7b">${{ dotaItem.price }}</h5>
              </div>
            </div>
          </div>
          <div class="box">
            <img
              class="game_icon unselectable"
              :src="gameIcons.rust"
              alt="Rust"
            />
            <img
              class="featured_image_rust unselectable"
              :src="rustItem.icon"
              alt="Rust"
            />
            <div class="info">
              <h6>{{ rustItem.name }}</h6>
              <div class="f align-center g5">
                <VueIcon
                  icon="solar:tag-price-linear"
                  color="2bce7b"
                  height="24px"
                  width="24px"
                ></VueIcon>
                <h5 style="color: #2bce7b">${{ rustItem.price }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="game_info">
      <h3>Supported Games</h3>
      <div class="game_wrap">
        <div
          v-for="(game, index) in supportedGames"
          :key="index"
          class="number-wrapper g5"
        >
          <img :class="game.imgClass" :src="game.imgSrc" :alt="game.altText" />
          <p class="number-text">{{ game.text }}</p>
        </div>
      </div>
    </div>
    <div class="summary-numbers">
      <h3>Statistics</h3>
      <div class="number_wrap">
        <div
          v-for="(item, index) in animatedItems"
          :key="index"
          class="number-wrapper"
        >
          <div class="number">
            {{ Math.floor(item.currentValue)
            }}<span class="text-other">{{ item.suffix }}</span>
          </div>
          <p class="number-text">{{ item.text }}</p>
        </div>
      </div>
    </div>
    <div class="feature-info">
      <div class="text-center">
        <h3 class="text-white">Features</h3>
      </div>

      <div class="feature_section pb-5">
        <a
          v-for="(item, index) in features"
          :key="index"
          class="feature_card unselectable"
          :href="item.link"
          target="_blank"
        >
          <img
            :src="item.img"
            class="feature_img unselectable"
            alt="featured"
          />
          <h4 class="text-white">
            {{ item.title }}
          </h4>
          <div class="f align-center">
            <p class="text-white">
              {{ item.description }}
            </p>
          </div>
          <div class="quarter-circle go_route">
            <VueIcon
              icon="fluent:ios-arrow-right-24-filled"
              width="24px"
              style="color: white"
            ></VueIcon>
          </div>
        </a>
      </div>
    </div>
    <div class="support_info">
      <div></div>
      <h3>Supported Marketplaces</h3>
      <a href="marketplaces" class="detail-more"> See All </a>
    </div>

    <LogoSlider :items="MarketOptionsRef" />
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import cs2 from "../assets/images/cs2-banner.png";
import rust from "../assets/images/rust-banner.png";
import tf2 from "../assets/images/tf2-banner.png";
import dota from "../assets/images/dota2.png";
import dlore from "../assets/images/dlore.png";
import hook from "../assets/images/hook.png";
import ak from "../assets/images/rust-item.png";
import caseIcon from "../assets/images/case.png";
import tf2Icon from "../assets/images/tf2-key.png";
import transfer from "../assets/images/transfer.png";
import inventoryIcon from "../assets/images/briefcase.png";
import manage from "../assets/images/checklist.png";
import trend from "../assets/images/trend-chart.png";
import invest from "../assets/images/investments.png";
import gift from "../assets/images/gift.png";
import target from "../assets/images/target.png";

import portfolio from "../assets/images/portfolio.png";
import watchlist from "../assets/images/add-bookmark.png";
import LogoSlider from "../components/slider/LogoSlider.vue";
import MarketOptions from "../core/constants.js";
import { useHead } from "@unhead/vue";

export default {
  cs2,
  setup() {
    const gameIcons = ref({
      cs2: cs2,
      tf2: tf2,
      rust: rust,
      dota2: dota,
    });

    const MarketOptionsRef = ref(MarketOptions);
    const supportedGames = ref([
      {
        imgClass: "cs_img",
        imgSrc: cs2,
        altText: "CS2",
        text: "CS 2",
      },
      {
        imgClass: "dota_img",
        imgSrc: dota,
        altText: "Dota2",
        text: "Dota 2",
      },
      {
        imgClass: "rust_img",
        imgSrc: rust,
        altText: "Rust",
        text: "Rust (soon)",
      },
      {
        imgClass: "tf2_img",
        imgSrc: tf2,
        altText: "TF-2",
        text: "TF 2 (soon)",
      },
    ]);

    const summaryItems = ref([
      { value: 65, suffix: "K+", text: "Tracked Items", duration: 800 },
      { value: 500, suffix: "+", text: "Users", duration: 800 },
      { value: 24, suffix: "/7", text: "Support", duration: 800 },
    ]);

    const animatedItems = ref([]);
    const isAnimated = ref(false);

    const csItem = reactive({
      name: "AWP | Dragon Lore",
      color: "#EB4B4B",
      price: 4999,
      icon: dlore,
    });

    const tfItem = reactive({
      name: "Mann Co. Supply Crate Key",
      color: "#EB4B4B",
      price: 1.68,
      icon: tf2Icon,
      game: tf2,
    });

    const dotaItem = reactive({
      name: "Dragonclaw Hook",
      price: 129,
      icon: hook,
    });

    const rustItem = reactive({
      name: "AK47U | Alien Red",
      price: 129,
      icon: ak,
    });

    const features = ref([
      {
        title: "Case Opening Simulator",
        description: "Try your luck with the FREE CS2 case opening simulator.",
        img: caseIcon,
        link: "/cs2/simulator",
      },
      {
        title: "Manage Your Trades",
        description: "Manage all your trades at one place.",
        img: manage,
        link: "/dashboard",
      },
      {
        title: "Inventory",
        description: "Track your CS2, Dota2, TF2 and Rust inventories.",
        img: inventoryIcon,
        link: "/inventory",
      },
      {
        title: "Price Comparison",
        description:
          "Compare item prices across 20 marketplaces to maximize profits.",
        img: transfer,
        link: "/comparison",
      },
      {
        title: "Price Trends",
        description: "Get real-time updates on skin market trends.",
        img: trend,
        link: "/trends",
      },
      {
        title: "Investment Tracker",
        description: "Track your item investments easily in one place.",
        img: invest,
        link: "/investments",
      },
      {
        title: "Portfolio",
        description:
          "Create a portfolio to easily track and analyze your total worth.",
        img: portfolio,
        link: "/analytics",
      },
      {
        title: "Watchlist",
        description:
          "Observe price movements by adding desired items to your watch list.",
        img: watchlist,
        link: "/watchlist",
      },
      {
        title: "Price Targets",
        description:
          "Get notified when the items you follow hit your target price drops.",
        img: target,
        link: "/target",
      },
      {
        title: "Free Giveaways",
        description:
          "Participate in free giveaways for a chance to win exclusive CS2 skins",
        img: gift,
        link: "/giveaways",
      },
    ]);

    const goUrl = (link) => {
      this.$router.push({ path: link });
    };

    const initIntersectionObserver = () => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isAnimated.value) {
              isAnimated.value = true;
              initAnimation();
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );

      const element = document.querySelector(".summary-numbers");
      if (element) {
        observer.observe(element);
      }
    };

    const initAnimation = () => {
      summaryItems.value.forEach((item) => {
        const isNumber = typeof item.value === "number";
        animatedItems.value.push({
          ...item,
          currentValue: isNumber ? 0 : item.value,
        });

        if (isNumber) {
          animateCount(
            animatedItems.value.length - 1,
            item.value,
            item.duration
          );
        }
      });
    };

    const animateCount = (index, targetValue, duration) => {
      const intervalTime = 20;
      const totalSteps = duration / intervalTime;

      const easeInOut = (t) => {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      };

      let currentStep = 0;
      const startValue = 0;

      const interval = setInterval(() => {
        if (currentStep < totalSteps) {
          const progress = currentStep / totalSteps;
          const easedProgress = easeInOut(progress);
          animatedItems.value[index].currentValue =
            startValue + easedProgress * targetValue;
          currentStep++;
        } else {
          animatedItems.value[index].currentValue = targetValue;
          clearInterval(interval);
        }
      }, intervalTime);
    };

    useHead({
      meta: [
        {
          name: "description",
          content:
            "Enhance your trading game with our comprehensive CS:GO, csgo stats, Dota 2, Rust, and TF2 items price analysis and inventory management tools for traders.",
        },
        {
          name: "keywords",
          content: `CS:GO, CS2, Dota 2, Rust, TF2, items, price analysis, Analyzer, inventory,CS:GO skins, csgo skins, csgo cases, csgo live stats, csgo knives, CS:GO trading, CS:GO in-game items,CS:GO virtual items, CS:GO cosmetic items, buy CS:GO skins, sell CS:GO skins, trade CS:GO skins, cryptocurrency, Steam, steam market analyzer, steam account analyzer, dragonclaw hook price history, csgo investment tracker, steam analyser, steam analysis, steam analyzer, secure trading, Rust skins,buy cs2 skins, sell cs2 skins, cs2 marketplace, buy csgo skins, sell csgo skins, csgo marketplace, csgo`,
        },
      ],
    });

    onMounted(() => {
      initIntersectionObserver();
    });

    return {
      MarketOptionsRef,
      supportedGames,
      summaryItems,
      animatedItems,
      isAnimated,
      csItem,
      tfItem,
      dotaItem,
      rustItem,
      features,
      goUrl,
      gameIcons,
    };
  },
  components: {
    LogoSlider,
  },
};
</script>

<style scoped>
.content-wrap {
  padding: 0rem 0rem;
}

p {
  margin-bottom: 0;
}

h1,
h3 {
  margin-bottom: 0px;
}

.feature-info {
  display: flex;
  flex-direction: column;
  padding-block: 4%;
  background-color: #0c0c15;
}

.feature_section {
  background-color: #0c0c15;
  min-height: auto;
  padding: 2rem 6rem;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.5rem;
}

.feature_card {
  border-radius: 4px;
  background-color: #18182b;
  padding: 1.3rem;
  max-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 20px;
  position: relative;
}

.feature_card p {
  font-size: 15px;
  font-weight: 400;
}

.feature_card h4 {
  font-size: 22px;
}

.feature_card:hover {
  transition: 0.3s;
  background-color: #282860;
  cursor: pointer;
}

h5 {
  margin-bottom: 0;
  font-weight: bold;
  font-size: 17px;
}

.game_icon {
  width: 30px;
  position: absolute;
  left: 10px;
  top: 10px;
  border-radius: 3px;
}

.tf2_game_icon {
  width: 40px !important;
}

.tf_key {
  margin-top: 10px !important;
}

.box {
  padding: 0.5rem;
  position: relative;
  width: 170px;
  height: 230px;
  display: flex;
  flex-direction: column;
  -ms-align-items: center;
  align-items: center;
  justify-content: space-evenly;
  background-color: green;
  border-radius: 3px;
  overflow: hidden;
  cursor: pointer;
}

.info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 5;
  width: 90%;
}

.box img {
  z-index: 5;
}

.box:hover,
.featured_image .featured_image_rust {
  filter: drop-shadow(0 0 10px #757373);
  transition: 0.5s;
  transform: translateY(-10px);
}

.box:not(hover),
.featured_image,
.featured_image_rust {
  transition: 0.4s;
}

.box h6 {
  font-size: 14px;
  z-index: 5;
}

.main {
  width: 100%;
  background: rgb(53, 53, 108);
  background: linear-gradient(
    38deg,
    rgba(53, 53, 108, 1) 0%,
    rgba(39, 39, 68, 1) 41%,
    rgba(46, 46, 85, 1) 100%
  );
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
}

.number_wrap {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
}

.images-wrapper {
  display: flex;
  flex-direction: row;
}

.game_wrap {
  display: flex;
  width: 90%;
  justify-content: space-around;
}

.markets_wrap {
  display: flex;
  flex-wrap: wrap;
  width: 90%;
}

.game_img {
  width: 60px;
}

.cs_img {
  width: 68px;
  height: 68px;
}

.tf2_img {
  width: 76px;
  height: 76px;
}

.dota_img {
  width: 78px;
  height: 78px;
}

.rust_img {
  width: 70px;
  height: 70px;
}

.skin_img {
  width: 90%;
  height: 230px;
}

.feature_img {
  width: 50px;
  height: 48px;
}

.featured_image {
  margin-top: 40px;
  width: 90%;
}

.featured_image_rust {
  margin-top: 20px;
  width: 90%;
  height: 60%;
}

.number-wrapper:hover > img {
  transition: 0.4s;
  cursor: pointer;
  filter: drop-shadow(0 0 11px #565555);
}

.images-wrapper > img {
  width: 50px;
}

.left-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 3%;
  margin-left: 7%;
  margin-bottom: 5%;
  margin-right: 0;
  width: 51%;
}

.left-wrapper > .title-part > h1,
h2 {
  animation: left-wrapper-anim 1s ease forwards;
}

@keyframes left-wrapper-anim {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(0);
  }
}

.right_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 49%;
  height: 100%;
  justify-content: center;
  padding: 2rem 0.5rem;
}

.left-wrapper h1 {
  font-size: 6rem;
  margin-bottom: 0%;
  margin-top: 0;
}

.left-wrapper h2 {
  font-size: 5rem;
  margin-bottom: 0%;
  margin-top: 0;
}

.left-wrapper > p {
  font-size: 1em;
  margin-bottom: 5%;
  margin-top: 0;
  text-wrap: wrap;
  width: 70%;
}

.left-bottom-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.left-bottom-text {
  margin-top: 5%;
  padding: 3%;
  display: flex;
  text-align: center;
  height: 100%;
}

.support_info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #21213b;
  color: white;
  padding-top: 2%;
  padding-right: 2%;
  gap: 5px;
}

.game_info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #21213b;
  color: white;
  padding-block: 3%;
  gap: 40px;
}

.summary-numbers {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3rem;
  justify-content: space-between;
  background-color: #1d1d34;
  color: white;
  padding-block: 2%;
  padding-inline: 3%;
  gap: 40px;
}

.number-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 130px;
  gap: 0;
}

.summary-numbers .number-wrapper .number-text {
  border-top: 1px solid #854cff;
  width: 150px;
  text-align: center;
}

.text-other {
  color: yellow;
  font-size: 24px;
}

.number-text {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.603);
}

a {
  cursor: pointer;
  text-decoration: none;
}

.feature_card:hover .go_route {
  transition: 0.2s;
  opacity: 1;
}

.go_route {
  opacity: 0;
}

.quarter-circle {
  padding-top: 8px;
  padding-left: 8px;
  width: 50px;
  height: 50px;
  background-color: #854cff;
  border-radius: 50px 0 0 0;
  -moz-border-radius: 50px 0 0 0;
  -webkit-border-radius: 50px 0 0 0;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-more:hover {
  color: rgb(218, 218, 41);
  transition: 0.3s;
}

@keyframes item-animation {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-30px);
  }
}

.box::before {
  content: "";
  position: absolute;
  height: 150%;
  width: 200%;
  background: linear-gradient(#00ccff, #d500f9);
  animation: rotate 2.4s linear infinite;
}

.box::after {
  content: "";
  position: absolute;
  background: #0e1538;
  inset: 5px;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.card::after {
  filter: blur(3.5rem);
}

@media screen and (max-width: 1230px) {
  .feature_section {
    grid-template-columns: repeat(4, 1fr);
    gap: 1.5rem;
  }

  .feature_card p {
    font-size: 13px;
  }

  .feature_card h4 {
    font-size: 18px;
  }
}

@media screen and (max-width: 976px) {
  .main {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 0.4rem 0.8rem;
  }

  .main .left-wrapper {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    margin-bottom: 1rem;
    justify-content: center;
    align-items: center;
    padding: 0.2rem 0.4rem;
    text-align: center;
  }

  .main .right_wrapper {
    width: 100%;
  }

  .main .left-wrapper h1 {
    font-size: 3.5rem;
    text-align: center;
  }

  .left-wrapper h2 {
    font-size: 3rem;
  }

  .sign_btn {
    width: 100%;
  }

  .box {
    width: 195px;
    height: 233px;
  }

  .left-bottom-wrapper {
    justify-content: center;
  }

  .feature_section {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap: 1.2rem;
    padding: 2rem 1.5rem;
    height: auto;
  }

  .feature_card h4 {
    font-size: 16px;
  }

  .feature_card p {
    font-size: 12px;
  }

  .feature_card {
    padding: 1rem;
    height: 200px;
    gap: 10px;
    border-radius: 1px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .detail-more {
    font-size: 13px;
  }

  .feature_card a {
    bottom: 13px;
    position: unset;
  }

  h3 {
    font-size: 20px;
  }
}

@media screen and (max-width: 476px) {
  .feature_card:hover .go_route {
    opacity: 0;
  }
  .summary-numbers .number-wrapper .number-text {
    width: 90px;
  }

  .left-wrapper > .title-part > h1 {
    animation: left-wrapper-anim-mobile 1s ease forwards;
  }

  @keyframes left-wrapper-anim-mobile {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .box {
    width: 50%;
    height: 255px;
  }

  .hidden {
    display: none;
  }

  .main .right_wrapper {
    margin-bottom: 1rem;
  }

  .game_info {
    padding-block: 4%;
    gap: 10px;
    height: 20vh;
    justify-content: space-around;
  }

  .feature-info {
    display: flex;
    flex-direction: column;
    padding-block: 2.5rem;
    background-color: #0c0c15;
  }

  .number-wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
  }

  .summary-numbers {
    padding-block: 4%;
    font-size: 2rem;
    height: 20vh;
    justify-content: space-around;
    gap: 10px;
  }

  .number-text {
    font-size: 0.8rem;
  }
  .support_info {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #21213b;
    color: white;
    padding-top: 4%;
  }

  h3 {
    font-size: 20px;
  }

  .detail {
    height: 50vh;
  }

  .manage_trades {
    height: 36vh;
  }
}
</style>
